<template>
  <div>
  <L1 class="restaurantTablesview">
    <template slot="slot_title">
      <Select :defaultValue="store" @input="$router.replace({ name: restaurantTablesv2[$event], query: { page: $event } })" :width="'665px'">
        <option v-for="rest in restaurants" :key="rest" :value="rest">{{rest}}</option>
      </Select>
      <input type="checkbox" v-model="wholeday" :label="'全天'">
      <DateInput :style="{marginLeft: 'auto'}" @input="date=$event" :defaultValue="date"/>
      <button :style="{marginRight: '32px'}" class="printBtn" @click="print">列印</button>
    </template>
    <LF :style="{padding: 0}">
    <template slot="filter">
      <template v-if="areas.length>0">
        <RadioTop :options="areas.map(e => e.name)" :defaultValue="areaname" @input="areaname=$event"/>
        <Search :defaultValue="searchText" @input="searchText=$event"/>
      </template>
    </template>
    <div class="container-storearea">
      <div>
        <div>
          <div class="smark">拖曳至灰色區域安排座位</div>
          <draggable class="sense" id="add-現場排位" :group="{name: 'tables', pull: 'clone', put: false}">
            <div class="now">
              <div>{{now}}</div>
              <div>現場排位</div>
              <div></div>
            </div>
          </draggable>
          <draggable class="sense" id="add-暫停使用" :group="{name: 'tables', pull: 'clone', put: false}">
            <div class="disable">
              <div>{{now}}</div>
              <div>暫停使用</div>
              <div></div>
            </div>
          </draggable>
          <div class="lists">
          <div class="list">預約排位</div>
          <div class="list">現場排位</div>
          <div class="list">空位</div>
          </div>
          <button :style="{marginTop: 'auto'}" class="refreshbtn" @click="tablesupdated"></button>
          <draggable class="deletebox"
          :group="{name: 'tables', pull: false, put: true}">
          </draggable>
          <div class="smark">拖曳至此刪除</div>
        </div>
      </div>

      <div class="right">
      <div class="area" ref="printhtml" id="printDinTable" :style="{
        width: `${area.width}px`,
        height: `${area.height}px`,
        marginInline: 'auto'
      }" v-if="area">
        <draggable v-for="(tb, t) in tables" :key="`tb-${t}`"
        :style="[{
          position: 'absolute',
          top: `${tb.coordinates[1]}px`,
          left: `${tb.coordinates[0]}px`,
          backgroundColor: '#E5E5E5'
        }, searchText && tb.client.find(e => match(e.orderer) || new RegExp(searchText, 'ig').test(e.ordererTel)) ? { transform: 'scale(1.2)' } : {}]"
        :id="tb.name"
        :group="{name: 'table', pull: true, put: true}"
        class="table"
        :class="[tb.style, tb.client&&tb.client.length > 0 ? 'hasClient' : '', tb.status ? 'hasStatus' : '']"
        @add="adding"
        @remove="removing">
        <div v-if="tb.status&&Object.keys(tb.status).length>0" class="item temp"
          :style="{backgroundColor: tb.status.orderer === '暫停使用' ? '#B9B9B9' : 'var(--color-pri)'}">
          <div>{{tb.name}}</div>
          <div>{{tb.status.orderer}}</div>
          <div>{{tb.status.visitTime}}</div>
          <div></div>
        </div>
        <div @dblclick="clientSelect=client" v-for="(client, i) in tb.client" :id="`client-${client._id}`" class="item" :key="`client-${t}-${i}`" :style="[{
          backgroundColor: client.color || 'var(--color-checked)', color: invertColor(client.color),
          display: toDate(client.visitDate) === date && moment(nowtime).isAfter(moment(`${date} ${client.visitTime}`).add(2, 'hour')) ? 'none' : 'flex'
        }, wholeday ? { display: 'flex' } : {}]">
          <div :style="{display: 'flex', width: 'fit-content', alignItems: 'center'}">
            <div :style="{
              marginLeft: 0, marginRight: '3px',width: '16px', height: '16px', border: '3px solid #FFF', borderRadius: '50%', backgroundColor:'#FFF', position:'relative',
              alignItems:'center', justifyContent:'center', display: 'flex'
            }"
            v-if="client.level">
              <img class="levelvip" :style="{width: '12px', height: '12px'}" v-if="client.level===1" :src="'./vip.svg'" alt="">
              <img class="levelvvip" :style="{width: '12px', height: '12px'}" v-else-if="client.level===2" :src="'./vvip.svg'" alt="">
              <img class="levelsupervip" :style="{width: '12px', height: '12px'}" v-else-if="client.level===3" :src="'./supervip.svg'" alt="">
            </div>
            {{client.orderer}}</div>
          <div>{{client.visitTime}}</div>
          <div v-if="client.reserveNumChild"><span>{{client.reserveNum}}大</span><span>{{client.reserveNumChild}}小</span></div>
          <div v-else><span>{{client.reserveNum}}人</span></div>
          <div class="notprint">{{client.ordererTel}}</div>
        </div>
        </draggable>
      </div>
    </div>
    </div>
    </LF>
  </L1>
  <EditCube :storeType="storeType" :types="types"
   @updateItem="tablesupdated" @close="clientSelect=null"
   :item="clientSelect" :salesmans="salesmans" :projects="projects"
   :statuslist="statuslistselectable" :products="products"/>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { convert, pinyin, match } from 'pinyin-pro'
import Search from '../../components/input/search.vue'
import EditCube from '../restaurantView/edit.vue'
import DateInput from '../../components/dateRadio/DatesSelectSingle.vue'
import Select from '../../components/select.vue'
import RadioTop from '../../components/radio/r1.vue'
import L1 from '../../components/layout/L1.vue'
import LF from '../../components/layout/LaTable.vue'
import draggable from 'vuedraggable'
import { getapi, postapi } from '../../store/fetch'
export default {
  name: 'tables',
  components: {
    draggable,
    RadioTop,
    L1,
    LF,
    Select,
    DateInput,
    EditCube,
    Search
  },
  computed: {
    ...mapState({
      restaurantsInfos: 'restaurantsInfos',
      defaultStore: 'defaultStore',
      restaurantTablesv2: 'restaurantTablesv2'
    }),
    store () {
      return this.$route.query.page
    },
    storeType () {
      if (this.store) {
        return this.$store.getters.getStoreType(this.store)
      } else {
        return null
      }
    },
    types () {
      if (this.store) {
        return this.$store.getters.getTypeList(this.store)
      } else {
        return []
      }
    },
    restaurants () {
      return this.restaurantsInfos.filter(e => e.storeType === 'restaurant').map(e => e.name)
    },
    area () {
      if (this.areaname && this.areas.length > 0) {
        return this.areas.find(e => e.name === this.areaname)
      } else {
        return null
      }
    }
  },
  beforeDestroy () {
    this.onListen(false)
  },
  async mounted () {
    setInterval(() => {
      this.nowtime = this.moment()
    }, 5 * 60 * 1000)
    if (global.socket && global.socket.connected) {
      this.onListen(true)
    }
    this.areas = await getapi(`tables/store/${this.store}`)
    this.areaname = this.areas[0]?.name
    // console.log('area', this.area)
    const salesmans = await getapi('users/local/short')
    this.salesmans = salesmans
  },
  data () {
    return {
      wholeday: false,
      searchText: null,
      clientSelect: null,
      date: this.moment().format('YYYY-MM-DD'),
      areaname: null,
      item: null,
      areas: [],
      tables: [],
      now: this.moment().format('HH:mm:ss'),
      itemSelect: null,
      nowtime: this.moment(),
      loading: false,
      projects: [],
      products: [],
      salesmans: [],
      statuslistselectable: ['預約中', '已報到', '已確認', '已完成', '已取消']
    }
  },
  watch: {
    store: {
      async handler () {
        if (this.store) {
          this.areas = await getapi(`tables/store/${this.store}`)
          this.areaname = this.areas[0]?.name
          const projects = await getapi(`restaurantSetting/${this.store}/restProject`)
          this.projects = projects
          const products = await getapi(`rest_product/category/${this.store}`)
          this.products = products
        }
      },
      immediate: true
    },
    wholeday () {
      this.tablesupdated(true)
    },
    areaname () {
      this.tablesupdated(true)
    },
    date () {
      this.tablesupdated(true)
    }
  },
  methods: {
    match (string) {
      console.log([string, convert(pinyin(this.searchText), { format: 'toneNone' })], 'match')
      return match(string, convert(pinyin(this.searchText), { format: 'toneNone' }))
    },
    convert (string) {
      return convert(string, { format: 'tonenone' }).replace(' ', '')
    },
    seatTook (item) {
      if (item.store === this.store && this.date === this.toDate(item.visitDate)) {
        item.tables.map(table => {
          const toTableIndex = this.tables.map(e => e.name).indexOf(table)
          if (toTableIndex >= 0) {
            this.tables[toTableIndex].client.push(item)
          }
        })
      }
    },
    tableMoved (item) {
      if (item.store === this.store && this.date === this.toDate(item.visitDate)) {
        console.log('tablemoved', item)
        const { move: { from, to } } = item
        if (from) {
          const FromTableIndex = from ? this.tables.map(e => e.name).indexOf(from) : null
          const index = this.tables[FromTableIndex].client.map(e => e._id).indexOf(item._id)
          if (index >= 0) {
            this.tables[FromTableIndex].client.splice(index, 1)
          }
        }
        const toTableIndex = this.tables.map(e => e.name).indexOf(to)
        if (toTableIndex >= 0) {
          this.tables[toTableIndex].client.push(item)
        }
      }
    },
    orderUpdate (item) {
      if (item.store === this.store && this.date === this.toDate(item.visitDate)) {
        if (item.status === '已完成' || item.status === '已取消') {
          item.tables.map(table => {
            const toTableIndex = this.tables.map(e => e.name).indexOf(table)
            if (toTableIndex >= 0) {
              const index = this.tables[toTableIndex].client.map(e => e._id).indexOf(item._id)
              this.tables[toTableIndex].client.splice(index, 1)
            }
          })
        }
      }
    },
    onListen (bool) {
      if (bool) {
        global.socket.on('tablemoved', this.tableMoved)
        global.socket.on('seatTook', this.seatTook)
        global.socket.on('newOrder', this.seatTook)
        global.socket.on('OnlineNewOrder', this.seatTook)
        global.socket.on('orderUpdate', this.orderUpdate)
        global.socket.on('cancelOrder', this.orderUpdate)
      } else {
        global.socket.off('tablemoved', this.tableMoved)
        global.socket.off('seatTook', this.seatTook)
        global.socket.off('newOrder', this.seatTook)
        global.socket.off('OnlineNewOrder', this.seatTook)
        global.socket.off('orderUpdate', this.orderUpdate)
        global.socket.off('cancelOrder', this.orderUpdate)
      }
    },
    async tablesupdated (setFetching) {
      if (setFetching) this.$store.commit('setFetching', true)
      this.tables = []
      this.$nextTick(async () => {
        if (this.store && this.areaname) {
          const tables = await getapi(`restaurant/table/${this.store}/${this.areaname}?` + new URLSearchParams({
            date: this.moment(this.date).startOf('day').toISOString(),
            wholeday: this.wholeday
          }), null, !!setFetching)
          this.tables = tables
        } else {
          this.tables = []
        }
        this.$store.commit('setFetching', false)
      })
    },
    async removing (ev) {
      this.$store.commit('setFetching', true)
      const to = ev.to.id
      if (!to) {
        const action = /client-/.test(ev.item.id) ? 'remove' : 'status-remove'
        const from = /sheet-/.test(ev.from.id) ? ev.from.id : ev.from.id
        const item = /client-/.test(ev.item.id) ? ev.item.id.replace('client-', '') : ev.from.id.replace('sheet-', '')
        // console.log('remove', [action, from, to, item])
        switch (action) {
          case 'remove':
            await postapi(`restaurant/removetable/${item}`, { from }, false)
            break
          case 'status-remove':
            await postapi(`tables/table/name/${from}`, {
              status: null
            }, false)
            break
          default:
            break
        }
        setTimeout(async () => {
          await this.tablesupdated(false)
          this.$store.commit('setFetching', false)
        }, 200)
      }
    },
    async adding (ev) {
      this.$store.commit('setFetching', true)
      // console.log('eveveev', [ev.from, ev.to, ev.item])
      const action = /add-/.test(ev.from.id) ? 'add' : /client-/.test(ev.item.id) ? 'move' : 'status-move'
      const from = /add-/.test(ev.from.id) ? ev.from.id : ev.from.id
      const to = ev.to.id
      const item = /client-/.test(ev.item.id) ? ev.item.id.replace('client-', '') : ev.from.id.replace('add-', '')
      // console.log('eveveev', [action, from, to, item])
      switch (action) {
        case 'add':
          await postapi(`tables/table/name/${to}`, {
            status: {
              orderer: item,
              visitTime: this.moment().format('HH:mm')
            }
          }, false)
          break
        case 'move':
          console.log('move', item, from, to)
          await postapi(`restaurant/movetable/${item}`, { from, to }, false)
          break
        case 'status-move':
          await postapi('tables/table/status/move', { from, to }, false)
          break
        default:
          break
      }
      setTimeout(async () => {
        await this.tablesupdated(false)
        this.$store.commit('setFetching', false)
      }, 200)
    },
    print () {
      const css = `
      @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&family=Roboto:wght@100;300;400;500;700;900&display=swap');
      @page {size:landscape;width: 297mm;height: 210mm;margin: 0 10px;padding: 0;-webkit-print-color-adjust: none;}
      .table {
        flex: 1;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;
        border: 1px solid #000;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        letter-spacing: .1em;
      }
      .table::before {
        content: attr(id);
        position: absolute;
        top: 5px;
      }
      .table.hasStatus::before {
        display: none;
      }
      .table.hasClient::before {
        display: none;
      }
      .vip, .vvip, .supervip {
        width: 30px;
        height: 30px;
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        margin: auto;
      }
      .vip {
        background-image: url(/vip.svg);
      }
      .vvip {
        background-image: url(/vvip.svg);
      }
      .supervip {
        background-image: url(/supervip.svg);
      }
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        width: 100%;
      }
      .item div {
        color: #000000!important;
      }
      .big_round {
        border-radius: 113px;
        width: 226px;
        height: 226px;
        box-sizing: border-box;
        background-color: #E5E5E5;
        position: absolute;
      }
      .small_round {
        border-radius: 67.5px;
        width: 135px;
        height: 135px;
        box-sizing: border-box;
        background-color: #E5E5E5;
        position: absolute;
      }
      .big_rect {
        border-radius: 5px;
        width: 120px;
        height: 160px;
        box-sizing: border-box;
        background-color: #E5E5E5;
        position: absolute;
      }
      .big_rect.rotate {
        border-radius: 5px;
        width: 160px;
        height: 120px;
        box-sizing: border-box;
        background-color: #E5E5E5;
        position: absolute;
      }
      .small_rect {
        border-radius: 5px;
        width: 120px;
        height: 120px;
        box-sizing: border-box;
        background-color: #E5E5E5;
        position: absolute;
      }
      .notprint {
        display: none;
      }
      `
      const levelElem1 = document.getElementsByClassName('levelvip')
      Array.from(levelElem1).map(ele => {
        ele.src = window.location.origin + window.location.pathname + '/vip.svg'
      })
      const levelElem2 = document.getElementsByClassName('levelvvip')
      Array.from(levelElem2).map(ele => {
        ele.src = window.location.origin + window.location.pathname + '/vvip.svg'
      })
      const levelElem3 = document.getElementsByClassName('levelsupervip')
      Array.from(levelElem3).map(ele => {
        ele.src = window.location.origin + window.location.pathname + '/supervip.svg'
      })
      const content = document.getElementById('printDinTable')
      const ht = document.createElement('html')
      const head = document.createElement('head')
      const body = document.createElement('body')
      const title = document.createElement('title')
      title.innerText = `${this.store} ${this.areaname} ${this.date}`
      const div = document.createElement('div')
      div.id = 'printDinTable'
      div.innerHTML = content.innerHTML

      body.appendChild(div)
      head.appendChild(title)
      const style = document.createElement('style')
      style.type = 'text/css'
      style.media = 'print'
      style.appendChild(document.createTextNode(css))
      const style1 = document.createElement('style')
      style1.type = 'text/css'
      style1.media = 'screen'
      style1.appendChild(document.createTextNode(css))
      head.appendChild(style)
      head.appendChild(style1)
      ht.appendChild(head)
      ht.appendChild(body)
      const printWin = window.open('', '', '')
      printWin.document.write(`<html>${ht.innerHTML}</html>`)
      printWin.document.close()
      setTimeout(() => {
        printWin.print()
      }, 500)
      return false
    }
  }
}
</script>
<style lang="scss">
.restaurantTablesview {
  .filter {
    border-bottom: 1px solid #CACACA;
    width: 100%;
    padding-right: 20px;
  }
  .LaTable-body {
    overflow-y: hidden;
  }
}
</style>
<style lang="scss">
.customDate {
  .field-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
</style>
<style lang="scss" scoped>
.refreshbtn {
  width: 170px;
  height: 100px;
  background-color: #7FA451;
  border-radius: 10px;
  color: #FFFFFF;
  letter-spacing: .1em;
  font-size: 20px;
  border: none;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  &::before {
    content: '';
    display: inline-flex;
    width: 40px;
    height: 42px;
    background-image: url(/refresh.svg);
  }
  &::after {
    content: '刷新狀態';
  }

}
.vip, .vvip, .supervip {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  margin: auto;
}
.vip {
  background-image: url(/vip.svg);
}
.vvip {
  background-image: url(/vvip.svg);
}
.supervip {
  background-image: url(/supervip.svg);
}
.printBtn {
  width: 110px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  background-color: var(--color-checked);
  border-radius: 25px;
  border: none;
  &::before {
    content: '';
    width: 25px;
    height: 25px;
    display: inline-block;
    background-image: url(/print.svg);
    background-repeat: no-repeat;
    background-position: center;
  }
}
.customDate {
  display: flex;
  position: fixed;
  top: 74px;
  right: 50px;
  width: 280px;
  height: 80px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  background-color: #FFFFFF;
  border-radius: 5px;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  button {
    height: 36px;
    width: 36px;
    border: none;
    &::before {
      content: '⤫';
      font-size: 24px;
    }
  }
}
.deletebox {
  background-image: url(/delete.svg);
  width: 100%;
  height: 100px;
  background-size: 60px;
  background-position: center;
  background-repeat: no-repeat;
  &>div {
    display: none;
  }
}
.areasbox {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
}
.areas {
  position: relative;
  &>div {
    position: absolute;
    // transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    &.big_round {
      border-radius: 113px;
      width: 226px;
      height: 226px;
      box-sizing: border-box;
      background-color: #E5E5E5;
      position: absolute;
    }
    &.small_round {
      border-radius: 67.5px;
      width: 135px;
      height: 135px;
      box-sizing: border-box;
      background-color: #E5E5E5;
      position: absolute;
    }
    &.big_rect {
      border-radius: 5px;
      width: 120px;
      height: 160px;
      box-sizing: border-box;
      background-color: #E5E5E5;
      position: absolute;
    }
    &.big_rect.rotate {
      border-radius: 5px;
      width: 160px;
      height: 120px;
      box-sizing: border-box;
      background-color: #E5E5E5;
      position: absolute;
    }
    &.small_rect {
      border-radius: 5px;
      width: 120px;
      height: 120px;
      box-sizing: border-box;
      background-color: #E5E5E5;
      position: absolute;
    }
    &>div{
      width: -webkit-fill-available;
      height: -webkit-fill-available;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 0;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      letter-spacing: 0.1em;
      color: #FFFFFF;
      position: relative;
      &>div:nth-child(1) {
        position: relative;
        z-index: 9;
      }
      &:hover > div:nth-child(1):before {
        position: absolute;
        width: 120px;
        content: attr(label);
        top: 20px;
        left: 50%;
        background-color: #FF0000;
        color: #FFFFFF;
        transform: translateX(-60px);
        z-index: 20;
      }
      &.now {
        background-color: var(--color-現場);
        display: none;
      }
      &.disable {
        display: none;
      }
      &.dragged {
        background-color: var(--color-暫停);
      }
      &.dragged_now {
        background-color: var(--color-現場);
        &.noToday {
          display: none;
        }
      }
      &.現場 {
        display: none;
      }
      &.bgc-0 { background-color: var(--color-home-0); }
      &.bgc-1 { background-color: var(--color-home-1); }
      &.bgc-2 { background-color: var(--color-home-2); }
      &.bgc-3 { background-color: var(--color-home-3); }
      &.bgc-4 { background-color: var(--color-home-4); }
      &.bgc-5 { background-color: var(--color-home-5); }
      &.bgc-6 { background-color: var(--color-home-6); }
    }
    &>div {
      z-index: 9;
    }
    &::before {
      content: attr(id);
      display: inline-block;
      position: absolute;
      width: 82px;
      height: 20px;
      font-size: 18px;
      color: #959595;
      z-index: 1;
      transform: translateY(-40px);
      text-align: center;
    }
    &:hover::before {
      background-color: #000000;
      color: #FFFFFF;
      z-index: 10;
    }
  }

}
.lists {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: start;
  padding-inline: 12px;
  box-sizing: border-box;
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #959595;
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 5px;
      display: inline-block;
      margin-right: 5px;
    }
    &:nth-child(1)::before {
      background-color: var(--color-home-4);
    }
    &:nth-child(2)::before {
      background-color: var(--color-home-5);
    }
    &:nth-child(3)::before {
      background-color: #E5E5E5;
    }
  }
}
.sense > div:nth-child(1) {
  box-sizing: border-box;
  width: 170px;
  height: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  &::before {
    content: '';
    width: 40px;
    height: 30px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  &::after {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &.now {
    background-color: var(--color-checked);
    &::before {
      background-image: url(/table.svg);
    }
    &::after {
      content: '現場排位';
    }
  }
  &.disable {
    background-color: var(--color-border);
    &::before {
      background-image: url(/cross.svg);
    }
    &::after {
      content: '暫停使用';
    }
  }
  &>div {
    display: none;
  }
}
.sense {
  display: flex;
  flex-direction: column;

  gap: 20px;
}
.container-storearea {
  display: grid;
  grid-template-columns: 200px 1fr;
  height: calc(100vh - 161px);
  &>:nth-child(1) {
    border-right: 1px solid var(--color-border);
    padding-inline: 13px;
    padding-block: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    &>div {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: flex-start;
      gap: 8px;
      height: 100%;
    }
    .smark {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.1em;
      color: #959595;
    }
  }
}
.restaurantSet {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 89px 1fr;
  height: 100%;
}
.restaurantTablesview input[type=radio] {
  width: 145px;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);  }

  &:checked {
    background-color: var(--color-checked);
  }
}
.restaurantTablesview input[type=checkbox] {
  width: fit-content;
  padding-inline: 1em;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(label);  }
  &:checked {
    background-color: var(--color-checked);
  }
}

.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 55px;
    mask-image: url(/tables.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-pri);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 10px;
}
.right {
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: auto;
  max-height: calc(100vh - 160px);
  .area {
    position: relative;
    z-index: 10;
    .table {
      overflow: hidden;
      position: absolute;
      background-color: #B9B9B9;
      display: grid;
      grid-template-columns: 1fr;
      z-index: 10;
      &:hover {
        overflow: unset;
        z-index: 999;
      }
      &>.disable, &>.now {
        display: none;
      }
      &::before {
        content: attr(id);
        position: absolute;
        top: 10px;
        left: 10px;
        right: 10px;
        display: inline-block;
        height: 1.5em;
        color: #5E5E5E;
        z-index: 11;
        font-size: 16px;
      }
      &.small_round {
        width: 135px;
        height: 135px;
        border-radius: 50%;
      }
      &.big_round {
        width: 226px;
        height: 226px;
        border-radius: 50%;
      }
      &.big_rect {
        border-radius: 5px;
        width: 120px;
        height: 160px;
        box-sizing: border-box;
        background-color: #E5E5E5;
      }
      &.big_rect.rotate {
        border-radius: 5px;
        width: 160px;
        height: 120px;
        box-sizing: border-box;
        background-color: #E5E5E5;
      }
      &.small_rect {
        border-radius: 5px;
        width: 120px;
        height: 120px;
        box-sizing: border-box;
        background-color: #E5E5E5;
      }
      &.small_rect.rotate {
        border-radius: 5px;
        width: 120px;
        height: 120px;
        box-sizing: border-box;
        background-color: #E5E5E5;
      }
      .temp, .stop {
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      &>div.item{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: -webkit-fill-available;
        z-index: 12;
        position: relative;
        &>div:last-child {
          display: none
        }
        &:hover>div:last-child {
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          background-color: var(--highlight);
          color: #FFFFFF;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
